module.exports = __webpack_public_path__ + "static/media/Illus-Apple_Wallet.d34632c0.png";